import {defineMessages} from 'react-intl';

export const messages = defineMessages({
    RENAULT_TRUCKS: {
        id: 'techDoc.requestForPartnerList.option.renaultTruck',
        defaultMessage: 'RENAULT TRUCKS'
    },
    NISSAN: {
        id: 'techDoc.requestForPartnerList.option.nissan',
        defaultMessage: 'NISSAN'
    },
    MITSUBISHI: {
        id: 'techDoc.requestForPartnerList.option.mitsubishi',
        defaultMessage: 'MITSUBISHI'
    },
    OPEL_VAUXHALL: {
        id: 'techDoc.requestForPartnerList.option.opelVauxhall',
        defaultMessage: 'OPEL-VAUXHALL'
    },
    FIAT: {
        id: 'techDoc.requestForPartnerList.option.fiat',
        defaultMessage: 'FIAT'
    },
    DAIMLER: {
        id: 'techDoc.requestForPartnerList.option.daimler',
        defaultMessage: 'DAIMLER'
    },
    LACOUR: {
        id: 'techDoc.requestForPartnerList.option.lacour',
        defaultMessage: 'LACOUR'
    },
});

export default messages;
